import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { AuthenticateService } from '../shared/services/authenticate.service';
import { Groupsservice } from 'src/app/shared/services/groups.service';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { EcommerceService } from 'src/app/shared/services/ecommerce.service';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.sass']
})
export class ProductsComponent implements OnInit {

  ProductForm: FormGroup;
  showDetails: boolean = true;
  urls = [];
  imageNameList = [];
  imageUploadService: string;
  uploadFileList: any = [];
  unit = '';
  imgUrl = this.authService.s3url();
  public loading: boolean;
  groupName: string;
  cropDataArray: any = [];
  showcrop: any[] = [];
  seedsDataArray: any = [];
  commonnameArray: any = [];
  technicalnameArray: any = [];
  productObj: any = {};
  productType: any;
  showvariants: boolean = false;
  tempArray: any = [];
  multiArray: any = [];
  collectionSize: any;
  previousPage: any;
  skip: number;
  page = 1;
  searchStr: string = '';
  showsearchdata: boolean = true;
  type: string = 'save';
  size: number = 0;
  cropuuid: string = '';
  tempcropArray: any = [];
  ferticollectionSize: any;
  fertiPreviousPage: any;
  fertiSkip: number;
  fertilizersDataArray: any = [];
  pesticollectionSize: any;
  pestiPreviousPage: any;
  pestiSkip: number;
  pesticidesDataArray: any = [];
  typeId: string = 'seeds';
  showAlert: boolean = false;
  subGroupsArray: any;
  selectSubGroupList: any = [];
  selectedRecord: any;
  mainCropImage: any;
  maincropUrl: string = '';
  maincropId: string = '';
  mainImageUploadService: string;
  btnLoading: boolean;
  touched: boolean = false;
  uploadMultipleFileList = [];
  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private cognitoService: CognitoService,
    private ecommService: EcommerceService,
    private groupsservice: Groupsservice,
    private fileUploadService: FileUploadService) { }

  // ngDoCheck() {
  //   if (!this.groupName) {
  //     this.groupName = this.tokenService.getGroup();
  //    }
  // }

  ngOnInit() {
    this.cognitoService.getCurrentUserToken().then((res: any) => {
      if (res && res.attributes && res.attributes.family_name) {
        this.groupName = res.attributes.family_name;
        // setTimeout(() => {
        this.getAllProducts();
        this.getAllSubGroups();
        // }, 1000);
      }
    })
    this.ProductForm = this.formBuilder.group({
      productName: ['', Validators.required],
      manufacturerName: [''],
      productDescription: ['', Validators.required],
      type: ['', Validators.required],
      size: [''],
      unit: ['', Validators.required],
      sku: ['', Validators.required],
      barCode: [''],
      mrpPrice: ['', Validators.required],
      available: ['', Validators.required]
    });
  }
  productConfig = {
    displayKey: 'name',
    search: true,
    limitTo: 200,
    height: '225px',
    placeholder: 'Select category'
  };
  getAllSubGroups() {
    let temp = [];
    this.selectSubGroupList = [];
    this.subGroupsArray = [];
    this.groupsservice.getAllECSubGroups({}).then((data: any) => {
      if (data.length > 0) {
        data.forEach(element => {
          let obj = {
            uuid: element.uuid,
            name: element.name,
          }
          temp.push(obj);
        });
        this.subGroupsArray = temp.sort((a, b) => a.name.localeCompare(b.name));
      }
    });
  }
  getSelectedGroup(e) {
    this.selectedRecord = e
    this.productObj['category'] = e;
  }

  getAllSeeds() {
    this.page = 1;
    this.loading = true;
    this.showsearchdata = true;
    this.seedsDataArray = [];
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: 0,
      // }
    }
    this.ecommService.getAllProducts(options).then((data: any) => {
      if (data.length > 0) {
        this.seedsDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = { group: this.groupName }
    this.ecommService.getProductsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    this.loading = true;
    this.seedsDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Seeds',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // }
    }
    this.ecommService.getAllProducts(options).then((data: any) => {
      if (data.length > 0) {
        this.seedsDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName, productType: 'Seeds' }
    this.ecommService.getProductsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  getAllProducts() {
    this.getAllSeeds();
  }
  selectvariants(event) {
    if (event.target.checked == false) {
      this.showAlert = true;
      this.tempArray = [];
      this.size = null;
    }
    this.showvariants = !this.showvariants;
  }
  gettouched(size) {
    if (size == null || size == undefined || size == 0) {
      this.touched = true;
    } else {
      this.touched = false;
    }

  }
  restrictAlphabets(e) {
    var x = e.which || e.keycode;
    if ((x >= 48 && x <= 57) || x == 8 ||
      (x >= 35 && x <= 40) || x == 46) {
      return true;
    } else {
      return false;
    }
  }
  deleteSize(index) {
    this.tempArray.splice(index, 1);
  }
  editproductData(data) {
    this.showAlert = false;
    this.showDetails = false;
    this.imageNameList = [];
    this.maincropUrl = '';
    this.uploadFileList = [];
    this.uploadMultipleFileList = [];
    this.urls = [];
    this.productObj = { mrpPrice: '', productDescription: '', productName: '', varietyName: '', varietyCode: '', manufacturerName: '', size: null, unit: '', sku: '', barCode: '', productImages: [], available: true };
    this.ProductForm = this.formBuilder.group({
      mrpPrice: ['', Validators.required],
      available: ['', Validators.required],
      productDescription: ['', Validators.required],
      productName: ['', Validators.required],
      type: ['', Validators.required],
      manufacturerName: [''],
      size: [''],
      unit: [''],
      sku: ['', Validators.required],
      barCode: ['']
    });
    this.productObj = data;
    this.productType = data.category;
    this.tempArray = data.b2cPackageOptions;
    this.productObj.productId = data.productId
    this.imageNameList = data.productImages;
    this.maincropUrl = this.imgUrl + data.productImg;
    for (var i = 0; i < data.productImages.length; i++) {
      this.urls.push(this.imgUrl + data.productImages[i]);
      this.uploadFileList.push(this.imgUrl + data.productImages[i]);
    }
    this.type = 'update';
  }
  mainImageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.maincropUrl = event.target.result;
      }
      let iuuid = UUID.UUID();

      this.mainImageUploadService = iuuid + "." + event.target.files.item(0).type.split('/')[1];
      this.mainCropImage = event.target.files[0];
    }
  }
  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split('/')[0] == 'image') {
          var reader = new FileReader()
          reader.readAsDataURL(event.target.files[i]);
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          }
          let iuuid = UUID.UUID();
          this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set('file', event.target.files[i], this.imageUploadService);
          formData.append('name', this.imageUploadService)
          this.uploadFileList.push(formData);
          this.uploadMultipleFileList.push(formData);
        }
      }
    }
  }
  mainUploadFileToActivity() {
    if (this.mainCropImage != '') {
      this.fileUploadService.uploadFile(this.mainCropImage, this.mainImageUploadService);
    }
  }
  uploadFileToActivity() {
    for (var i = 0; i < this.uploadMultipleFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.uploadMultipleFileList[i].get('file'), this.imageNameList);
    }
  }

  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
  }

  onImgError(event) {
    event.target.src = this.imgUrl + 'agri_logo.png';
  }

  addmultipleSize(number, unit) {
    let sUnit;
    if (number != undefined && number != '' && unit != undefined && unit != '') {
      if (unit == 'Grams') {
        sUnit = 'gms'
      } else if (unit == 'Kgs') {
        sUnit = 'Kg'
      } else if (unit == 'Ton') {
        sUnit = 'T'
      } else if (unit == 'Quintal') {
        sUnit = 'Q'
      } else if (unit == 'dozen') {
        sUnit = 'Dozen'
      } else if (unit == 'pieces') {
        sUnit = 'Pieces'
      }
      let obj = {
        quantity: number,
        unit: unit,
        sUnit: sUnit,
        price: 0
      }
      this.tempArray.push(obj);
      this.size = null;
    }
  }

  addForms() {
    this.cropuuid = '';
    this.showDetails = false;
    this.productType = null;
    this.showvariants = false;
    this.ProductForm.reset();
    this.imageNameList = [];
    this.multiArray = [];
    this.urls = [];
    this.uploadFileList = [];
    this.uploadMultipleFileList = [];
    this.tempArray = [];
    this.size = null;
    this.type = 'save';
    this.maincropUrl = '';
    this.productObj = {};
  }

  backTomain() {
    this.loading = true;
    this.showDetails = true;
    this.showcrop[1] = false;
    this.showcrop[2] = false;
    this.showvariants = false;
    this.getAllSeeds();
  }
  onChangeState(event) {
    this.productObj.available = event.currentValue;
  }
  saveData() {
    this.loading = true
    this.btnLoading = true;
    var pobj;
    this.loading = true;
    let uuid = UUID.UUID();
    this.productObj['productId'] = uuid;
    this.productObj.productImages = this.imageNameList;
    this.productObj.productImg = this.mainImageUploadService;
    this.productObj.group = this.groupName;
    if (this.mainCropImage != undefined) {
      this.mainUploadFileToActivity();
    }
    if (this.imageUploadService) {
      this.uploadFileToActivity();
    }
    if (this.tempArray.length == 0) {
      this.tempArray[0] = 0;
      console.log("size not selected", this.tempArray[0]);
    }
    pobj = this.productObj;
    pobj['b2cPackageOptions'] = this.tempArray;
    this.ecommService.saveSingleProduct(pobj).then((data: any) => {
      this.btnLoading = false;
      if (data) {
        this.getAllSeeds();
        this.ProductForm.reset();
        this.imageNameList = [];
        this.mainCropImage = '';
        this.maincropUrl = '';
        this.urls = [];
        this.uploadFileList = [];
        this.uploadMultipleFileList = [];
        this.tempArray = [];
        this.size = null;
        this.showDetails = true;
        this.showvariants = false;
        this.productType = null;
        this.mainImageUploadService = '';
        Swal({ title: "Saved successfully" })
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  updateData() {
    this.loading = true;
    this.btnLoading = true;
    this.productObj.size = this.size;
    this.productObj['b2cPackageOptions'] = this.tempArray;
    this.productObj.productImg = this.mainImageUploadService;
    this.productObj.productImages = this.imageNameList;
    if (this.mainCropImage != undefined) {
      this.mainUploadFileToActivity();
    }
    if (this.imageUploadService) {
      this.uploadFileToActivity();
    }
    delete this.productObj._id;
    this.ecommService.updateProductData(this.productObj).then((data: any) => {
      this.btnLoading = false;
      if (data) {
        this.cropuuid = '';
        Swal({ title: "Updated successfully" })
        this.getAllSeeds();
        this.getAllProducts();
        this.ProductForm.reset();
        this.imageNameList = [];
        this.urls = [];
        this.uploadFileList = [];
        this.uploadMultipleFileList = [];
        this.tempArray = [];
        this.multiArray = [];
        this.size = null;
        this.showDetails = true;
        this.showcrop[1] = false;
        this.showcrop[2] = false;
        this.showvariants = false;
        this.productType = null;
        this.mainCropImage = '';
        this.maincropUrl = '';
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  searchByName() {
    console.log("type", this.typeId);
    if (this.searchStr != '') {
      this.loading = true;
      var obj = {
        group: this.groupName,
        field: 'productName',
        text: this.searchStr,
        tableName: 'productcoll',
      };
      console.log("search obj : ", obj)
      this.ecommService.getProductCollRegex(obj).then((data: any) => {
        console.log("searched", data);
        this.seedsDataArray = [];
        this.searchStr = '';
        if (data.length > 0) {
          this.seedsDataArray = data;
          this.showsearchdata = false;
          this.loading = false;
          console.log("seedsDataArray", this.seedsDataArray);
        }
        else {
          this.showsearchdata = false;
          this.loading = false;
        }
      })
    }
  }
}